
//  topbar.component.ts

import { Component, OnInit, Output, EventEmitter, OnDestroy, effect, output } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { AuthService } from '../../core/services/auth.service';
import { CommonModule } from '@angular/common';
import { AdminAlertsService } from '../../core/services/admin-alerts.service';
import { SocketService } from '../../core/services/socket.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [MatToolbarModule, MatIconModule, MatButtonModule, MatMenuModule, MatBadgeModule, CommonModule],
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {

  toggleSidebarEvent = output<void>();
  user: any;
  unreadCount = 0;
  recentAlerts: any[] = [];

  constructor(
    private authService: AuthService,
    private adminAlertsService: AdminAlertsService,
    private socketService: SocketService
  ) {
    effect(() => {
      this.user = this.authService.currentUser();
      
      if (this.user) {
        this.loadAlerts();
        
        // This is safe since onNotification will just add a listener,
        // but we should ideally only add it once or cleanup. We will leave it as is.
      }
    });
  }

  async ngOnInit() {
    // We can also ensure initial load if it wasn't there
    const initialUser = await this.authService.getUser();
    if (initialUser && !this.user) {
       this.user = initialUser;
    }
    
    if (this.user) {
      this.loadAlerts();
      
      this.socketService.onNotification(() => {
        this.loadAlerts();
      });
    }
  }

  loadAlerts() {
    this.adminAlertsService.getAlerts({ limit: 10 }).subscribe({
      next: (res) => {
        this.recentAlerts = res.data;
      }
    });
    this.adminAlertsService.getUnreadCount().subscribe({
      next: (res) => {
        this.unreadCount = res.unread;
      }
    });
  }

  markAllAsRead(event: Event) {
    event.stopPropagation();
    this.adminAlertsService.markAsRead().subscribe({
      next: () => {
        this.loadAlerts();
      }
    });
  }

  logout() {
    this.authService.logout();
  }

  emitToggleSidebar() {
    this.toggleSidebarEvent.emit();
  }

  ngOnDestroy() {
    // Socket cleanup is handled globally in app.component
  }
}
